export const COUNTERS = 'COUNTERS';
export const VISITS = 'VISITS';
export const EXPANDED = 'EXPANDED';
export const PAGINATION = 'PAGINATION';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
